"use strict";

$(document).ready(function () {
  if ($(".announcement-bar").length) {
    $("body").addClass("has-top-bar");
  }
  $('a:has(img)').addClass('img-link');
  $('.page_recover').click(function () {
    $(this).closest('#CustomerLoginForm').addClass('hide');
    $(this).closest('.page-width').find('#RecoverPasswordForm').removeClass('hide');
  });

  // popup variable
  var popup_show_count = 0;

  // mobile menut
  $('.btnclose_menu').click(function () {
    $('.js-mobile-nav-toggle').trigger('click');
  });
  if (currencyEnabled) {
    // $('.currency_list .curr_name[data-val="'+cookieCurrency+'"], .currency_dropdown').trigger("click");
    var curSelected = function curSelected(_this) {
      $('.currency_list .curr_name').removeClass('active');
      _this.addClass('active');
      var name = _this.html();
      var code = _this.attr('data-val');
      $('.currency_dropdown .currency_name').html(name);
      $('select[name=currencies]').val(code).trigger('change');
      var newCurrency = code;
      //console.log(Currency.currentCurrency, newCurrency)
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      $('.selected-currency').text(Currency.currentCurrency);
    };
    // currency select
    $('.currency_dropdown').click(function () {
      $('.currency_list').slideToggle();
    });
    $('.currency_list .curr_name').click(function () {
      curSelected($(this));
    });
    curSelected($('.currency_list .curr_name[data-val="' + cookieCurrency + '"]'));
  }

  // contact page gallery show
  show_contact_gallery();

  // home slider

  //slider_width();

  // sidebar prodcut
  fixed_sidebar();

  // home collection
  $('.coll_loadmore a').click(function (e) {
    e.preventDefault();
    $('.home_collection_box .single_home_product').show();
    $('.coll_loadmore').hide();
    $('.coll_loadmore_view').show();
  });
  $("body").on("click", ".blog_temp .Load_more a", function (event) {
    event.preventDefault();
    var url = $(this).attr('href');
    $.ajax({
      url: url,
      success: function success(data) {
        var result = $('<div />').append(data).find('.blog_section').html();
        var lm = $('<div />').append(data).find('.Load_more').html();
        if (typeof lm !== 'undefined') {
          $('.Load_more').html(lm);
        } else {
          $('.Load_more').html('');
          $('.Load_more').hide();
        }
        $('.blog_section').append(result);
        var i = 1;
        $('.blog_section li.grid__item').each(function () {
          if (i > 2) {
            $(this).removeClass('third_brack');
            $(this).removeClass('one-half');
            $(this).removeClass('one-third');
            $(this).addClass('one-third').attr('data-at', i);
            var at = i - 3;
            if (at % 3 == 0) {
              $(this).addClass('third_brack');
            }
          }
          i += 1;
        });
      }
    });
  });
  //support

  $('.support_box .support_heaing').click(function () {
    if ($(this).parent('.support_box').hasClass('active')) {
      $(this).parent('.support_box').removeClass('active');
    } else {
      $('.support_box.active .suport_text').slideToggle();
      $('.support_box').removeClass('active');
      $(this).parent('.support_box').addClass('active');
    }
    $(this).next('.suport_text').slideToggle();
  });

  // contact us

  // $('body').on('submit', '.page_contact_inner form', function(e){
  $('.page_contact_inner form').submit(function (e) {
    var error_mg = $(".error_msg").html();
    var msg_email = $(".msg_email").html();
    var err = 1;

    // user
    var err1 = error_msg_show($('input[type="text"].required.us_name'), error_mg);

    // email
    var err2 = error_msg_show($('input[type="email"].required.us_email'), error_mg);
    var id = $('input[type="email"].required.us_email').html();
    if (id != '') {
      err = valid_email($('input[type="email"].required.us_email'), msg_email);
    }

    // textarea
    var err3 = error_msg_show($('textarea.required.txt_msg'), error_mg);
    var err4 = error_msg_show($('input[type="text"].required.us_order'), error_mg);
    var err5 = error_msg_show($('input[type="text"].required.us_website'), error_mg);
    var err6 = error_msg_show($('input[type="text"].required.us_insta'), error_mg);
    if (err == 0 || err1 == 0 || err2 == 0 || err3 == 0 || err4 == 0 || err5 == 0 || err5 == 0) {
      return false;
    }
  });
  $('body').on('focusout', ".page_contact_inner .error_txt", function () {
    // $(".page_contact_inner .error_txt").focusout(function(){
    if ($(this).val != '') {
      $(this).removeClass('error_txt');
      $(this).next('.error_input').hide();
    }
  });
  $('body').on('focusout', ".page_contact_inner input[type='email']", function () {
    var msg_email = $(".msg_email").html();
    valid_email($(this), msg_email);
  });
  $('body').on('click', 'a.info_close', function () {
    $('.popup_full').fadeOut();
  });
  $('.cp_select_option').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }
    $('.cp_dd_option').slideToggle();
  });
  $('.cp_dd_option li').click(function () {
    var option_text = $(this).attr('data-option');
    $('.add_extra_filed .outer_style').hide();
    if (option_text == 1) {
      //if(!getCookie('popup'))  {
      $('.popup_full').html($('.contact_popup').html());
      $('.popup_full').fadeIn();
      //setCookie('popup','true');
      //}

      //option_text = 4;
      $('.full_contactform').hide();
    } else {
      $('.full_contactform').show();
      $('.add_extra_filed').find('input').removeClass('required');
      $('.add_extra_filed .outer_style[data-name="' + option_text + '"]').find('input').addClass('required');
      $('.add_extra_filed .outer_style[data-name="' + option_text + '"]').show();
      $('.add_extra_filed .outer_style[data-hide="' + option_text + '"]').hide();
      $('.cp_select_option').html($(this).html());
      $('.cp_dd_option').slideToggle();
      $('.cp_select_option').removeClass('active');
    }
  });

  // licence_info
  $('.License_info:not(.font) span').click(function () {
    $('.popup_full').html($('.license_details.popup_outer').html()); //.addClass("not_full");
    $('.popup_full').fadeIn('fast');
    $('body').addClass('fxd-active');
  });

  // licence_info for font
  $('.License_info.font span').click(function () {
    $('.popup_full').html($('.license_details.popup_outer.font').html()); //.addClass("not_full");
    $('.popup_full').fadeIn('fast');
    $('body').addClass('fxd-active');
  });
  $('li.site-footer__linklist-item a').click(function (e) {
    if ($(this).attr('href') == '/pages/user-licence-agreement') {
      $('.popup_full').html($('.license_details.popup_outer').html()); //.removeClass("not_full");
      $('.popup_full').fadeIn('fast');
      $('body').addClass('fxd-active');
      e.preventDefault();
    }
  });
  $('body').on('click', '.min_text_agree a, .cart-attribute__field a', function (e) {
    e.preventDefault();
    $('.popup_full').html($('.license_details.popup_outer:not(.font)').html()); //.removeClass("not_full");
    $('.popup_full').fadeIn('fast');
    $('body').addClass('fxd-active');
  });
  $('body').on('click', '.li_info_close', function () {
    $('.popup_full').fadeOut('fast');
    $('body').removeClass('fxd-active'); //.removeClass("not_full");

    if ($(this).hasClass('li_info_close')) {
      $('.popup_full').html('');
    }
  });

  //syad_heading

  $('.syad_heading').click(function () {
    $(this).toggleClass('active');
    $('.syad_txt').slideToggle();

    /*  var ps_top = $('.product_sidebar_inner').attr('style');
     ps_top = ps_top.split(':');
     ps_top = $.trim(ps_top[1]);
     ps_top = ps_top.replace("px", "");
      setTimeout(function(){
       if($('.syad_txt').height() > 1)
       {
       	ps_top = parseInt(ps_top)-$('.syad_txt').height()-68;
         $('.product_sidebar_inner').css('top', ps_top);
       }
       }, 400); */
  });
  prodDDFunctions($(".product-page-form.product-form"));
  if ($("body").hasClass("template-product") && $('.bundle-upsell-wrapper').length) {
    $(".bundle-upsell-wrapper .product-form.product-form-bundle-upsell").each(function (index) {
      prodDDFunctions($(this));
      addToCartButton($(this));
    });
    //Add listener for mobile upsells
    if ($('.mobile-upsells-wrapper').length) {
      prodDDFunctions($('.mobile-upsells-wrapper'));
      addToCartButton($('.mobile-upsells-wrapper'));
    }
  }
  if ($("body").hasClass("template-product")) {
    customBundleButton();
  }
  $('.slideshow + .next_prev_ext .Next_ext').click(function () {
    $(this).parent().prev().find('button.slick-next').trigger('click');
  });
  $('.slideshow + .next_prev_ext .prev_ext').click(function () {
    $(this).parent().prev().find('button.slick-prev').trigger('click');
  });
  $("a.anchor-link[data-href]").click(function (e) {
    e.preventDefault();
    var scroll = $($(this).attr("data-href")).position().top - 158;
    //console.log(scroll)
    $("html, body").animate({
      scrollTop: scroll
    }, 600, "linear");
  });

  // close bar
  $('.close_bar').click(function (e) {
    e.preventDefault();
    $('.announcement-bar').slideToggle();
    $('.template-index #shopify-section-header').addClass('remove_bar');
    $('[class*="index-section--flush"]:first-child').css("margin-top", "-30px");
  });
  // account
  $('a.site-header__account, .close_form').click(function (e) {
    if ($(this).hasClass('login_act')) {
      return;
    }
    e.preventDefault();
    $('.account_login_form').slideToggle();
    if ($('.account_login_form').hasClass('active')) {
      //$('#shopify-section-header').css('top', '0');
      $('#shopify-section-header').removeAttr('style').removeClass('login-active');
      $('main.main-content').removeAttr('style');
      $('.account_login_form').removeClass('active');
      $('.announcement-bar .close_bar').show();
    } else {
      $('#shopify-section-header').css('top', '250px').addClass('login-active');
      $('main.main-content').css('margin-top', '235px');
      $('.account_login_form').addClass('active');
      $('.announcement-bar .close_bar').hide();
    }
  });

  // sort by
  $('.select_sortby_name .option').click(function () {
    var opt = $(this).attr('value');
    $('.select_sortby').html('');
    $('.select_sortby').html($(this).html());
    $('select#SortBy').val(opt).trigger('change');
    $('.select_sortby_name').slideToggle();
  });
  $('.Custome_header_collection .btn_arrow').click(function (e) {
    e.preventDefault();
    $('.select_sortby_name').slideToggle();
  });
  var opt_name = $('select#SortBy').val();
  if (typeof opt_name !== 'undefined') {
    $('.select_sortby').html('');
    $('.select_sortby').html($('.select_sortby_name .option[value="' + opt_name + '"]').html());
    $('.select_sortby_name .option[value="' + opt_name + '"]').addClass('active');
  }
  if ($('body').hasClass('template-collection') || $('body').hasClass('template-index')) {
    remove_decimal();
  }
  if ($('body').hasClass('template-product')) {
    relpt_remove_decimal();
  }
});
function prodDDFunctions(wrapper) {
  setTimeout(function () {
    if (wrapper.find(".swatch_outer").length) {
      // product dropdown show
      wrapper.find('.swatch .Select_option').click(function () {
        console.log('swatch!');
        if ($(this).hasClass('active')) {
          $(this).next('.Show_drow_donw').slideUp();
          setTimeout(function (_el) {
            _el.removeClass('active');
          }, 450, $(this));
        } else {
          $(this).parent().find('.Select_option.active').next('.Show_drow_donw').slideUp();
          setTimeout(function (_el) {
            _el.siblings().removeClass('active');
          }, 450, $(this));
          $(this).next('.Show_drow_donw').slideDown();
          setTimeout(function (_el) {
            _el.addClass('active');
          }, 450, $(this));
        }
        if ($(this).parents(".swatch_outer").next().find('.qtyshow').hasClass('active')) {
          $(this).parents(".swatch_outer").next().find('.qty_dropdown').slideUp();
          setTimeout(function (_el) {
            _el.parents(".swatch_outer").next().find('.qtyshow').removeClass('active');
          }, 450, $(this));
        }
        $(this).closest("form").find('.Select_option.active').next('.Show_drow_donw').slideUp();
        setTimeout(function (_el) {
          _el.removeClass('active');
        }, 450, $(this).closest("form").find('.Select_option.active'));
      });

      // product swithch
      wrapper.find('.swatch .toggler .swatch-element').click(function (e) {
        var sw_value = String($(this).attr('data-value')).replace(/(<([^>]+)>)/ig, "");
        //console.log("swatch-element click", sw_value);
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        //console.log("option-index",optionIndex)
        $(this).closest('.swatch').find('.toggler').removeClass('active');
        $(this).parent('.toggler').addClass('active');
        var sel_dd = $(this).closest('form').find('select.single-option-selector').eq(optionIndex).val(sw_value);
        sel_dd.find("option").removeAttr("selected").siblings('[value="' + sw_value + '"]').attr("selected", "selected");
        sel_dd.trigger('change');
        $(this).parents('.single_option').parents('.Show_drow_donw').slideToggle();
        $(this).closest('.swatch').children('.Select_option').removeClass('active'); //.parent().addClass("made-selection");
        $(this).closest('.swatch').children('.Select_option').html($(this).children('label').html());
        //console.log("label",$(this).children('label').html())
        var _wrapper = $(".product-page-form.product-form");
        $(".product-template__container").removeClass("quick-view-active upsell-active");
        if ($(this).closest(".quick-view-popup").length) {
          _wrapper = $(".quick-view-popup .product-form");
          $(".product-template__container").addClass("quick-view-active");
          // _wrapper.find(".product-form__variants").eq($(this).parent().eq()).prop("selected");
          if (_wrapper.find(".swatch").length > 1) {
            updateVariantDropdowns(_wrapper, optionIndex, sw_value);
          } else {
            _wrapper.find(".product-form__variants").prop('selectedIndex', $(this).parent().index()).change();
          }
        } else if ($(this).closest(".bundle-upsell-wrapper").length) {
          $(".bundle-upsell-wrapper .product-form.product-form-bundle-upsell").removeClass("active");
          _wrapper = $(this).closest(".product-form.product-form-bundle-upsell");
          _wrapper.addClass("active");
          $(".product-template__container").addClass("upsell-active");
          if (_wrapper.find(".swatch").length > 1) {
            updateVariantDropdowns(_wrapper, optionIndex, sw_value);
          } else {
            _wrapper.find(".product-form__variants").prop('selectedIndex', $(this).parent().index()).change();
          }
        } else if (_wrapper.find(".swatch").length > 1) {
          updateVariantDropdowns(_wrapper, optionIndex, sw_value);
        } else {
          console.log($(this).parent().index());
          _wrapper.find(".product-form__variants").prop('selectedIndex', $(this).parent().index()).change();
          console.log(_wrapper.find(".product-form__variants").val());
        }

        //console.log($(this).parent().index())
        //console.log(_wrapper.serialize())

        disabled_button(_wrapper);
        change_price_btn(_wrapper);
      });
    }
    if (wrapper.find(".qtyshow_box_option").length) {
      wrapper.find('.qtyshow').click(function () {
        if (!$(this).hasClass('active')) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
        $(this).next('.qty_dropdown').slideToggle();
      });
      wrapper.find('.qty_dropdown li').click(function () {
        $(this).parents(".qty_dropdown").prev('.qtyshow').html($(this).html());
        $(this).parents('.qty_dropdown').slideToggle();
        $(this).parents(".qty_dropdown").prev('.qtyshow').removeClass('active');
        var qty = $(this).children('span').attr('data-qty');
        $(this).parents(".product-form__item").find('input.dropDown_inputQty').val(qty);

        //let _wrapper = $(".product-page-form.product-form");
        var _wrapper = $(".product-page-form.product-form");
        $(".product-template__container").removeClass("quick-view-active");
        if ($(this).closest(".quick-view-popup").length) {
          _wrapper = $(".quick-view-popup .product-form");
          $(".product-template__container").addClass("quick-view-active");
        }
        disabled_button(_wrapper);
        change_price_btn(_wrapper);
      });
    }
    if (wrapper.find(".swatch_outer").length == 0 && wrapper.find(".qtyshow_box_option").length == 0) {
      //enabled button since there are no dropdowns
      wrapper.find('button[type="submit"]').removeClass('btn_disabled');
    }
  }, 0);
}
function updateVariantDropdowns(_wrapper, optionIndex, sw_value) {
  //get and sold out variants
  var soldouts = [];
  _wrapper.find(".product-form__variants option").each(function () {
    if ($(this).text().indexOf("Sold out") != -1) {
      soldouts.push($(this).attr("data-product").split("|"));
    }
  });
  var vars = [];
  _wrapper.find(".swatch").each(function (index, value) {
    var curVar = $(this).find(".Select_option").text().trim();
    vars.push(curVar);
  });
  //console.log(vars);
  _wrapper.find(".swatch").each(function (_index) {
    if (_index != optionIndex) {
      //console.log(soldouts[_index]);
      $(this).find(".Show_drow_donw .toggler > div").parent().removeClass("disabled");
      for (var i = 0; i < soldouts.length; i++) {
        if (soldouts[i][optionIndex] == sw_value) {
          $(this).find(".Show_drow_donw .toggler > div[data-value='" + soldouts[i][_index] + "']").parent().addClass("disabled");
          //console.log(soldouts[i][_index])
        }
      }
    }
  });
  vars = vars.join(" / ");
  if (_wrapper.find(".product-form__variants option:contains('" + vars + "')").attr("disabled") == undefined) {
    _wrapper.find("button.product-form__cart-submit").prop('disabled', false).find("#AddToCartText").text(" - Add to cart");
    _wrapper.find(".product-form__variants").prop('selectedIndex', _wrapper.find(".product-form__variants option:contains('" + vars + "')").index()).change();
  } else {
    //soldout, disable button
    _wrapper.find("button.product-form__cart-submit").prop('disabled', true).find("#AddToCartText").text(" - Sold out");
  }
}
function disabled_button(_wrapper) {
  var selectot = true;
  if (_wrapper.find('.swatch_outer .swatch').length > 0) {
    _wrapper.find('.swatch_outer .swatch').each(function () {
      if ($(this).find('.Select_option').children('span').hasClass('select_opt')) {
        selectot = false;
      }
    });
  }
  if (!_wrapper.find('.qtyshow span').hasClass('select_opt') && selectot) {
    _wrapper.find('button[type="submit"]').removeClass('btn_disabled');
    _wrapper.find('.before_btntxt').hide();
    _wrapper.find('.after_btntxt').show();
  }
}
function change_price_btn(_wrapper) {
  //var qty = _wrapper.find('.qtyshow_box_option .qtyshow span').attr('data-qty');
  var qty = _wrapper.find('input.dropDown_inputQty').val();
  if (qty > 0) {
    setTimeout(function () {
      //var p_regular = Number($('.price_box_dt .price__regular .price-item').text());
      //var p_sale = Number($('.price_box_dt .price__sale .price-item').text());

      var sign = _wrapper.find('.price_box_dt').attr('data-money-sign').replace(_wrapper.find('.price_box_dt').attr('data-money'), '');
      var p_regular = Number(_wrapper.find(".product-form__variants option:selected").attr("data-price"));
      var p_sale = _wrapper.find(".product-form__variants option:selected").attr("data-compare-at-price") ? Number(_wrapper.find(".product-form__variants option:selected").attr("data-compare-at-price")) : 0;

      //console.log(p_regular,p_sale)

      _wrapper.find(".product__price .from-msg").hide();
      if (typeof p_sale === 'undefined') {
        p_sale = 0;
      }
      console.log(p_regular, p_sale, qty);
      if (p_regular > p_sale) {
        _wrapper.find('.price-item--regular').html(sign + p_regular * qty / 100);
      } else {
        _wrapper.find('.price-item--sale').text(sign + p_regular * qty / 100);
        _wrapper.find('.price-item--regular').text(sign + p_sale * qty / 100);
      }

      // console.log(shopCurrency, Currency.currentCurrency,'.price-item');

      if (currencyEnabled) Currency.convertAll(shopCurrency, Currency.currentCurrency, _wrapper.find('.price-item'), true);
    }, 10);
  }
}

//$('.product_slide_box').show();

$(window).scroll(function () {
  fixed_sidebar();
});
$(window).resize(function () {
  //slider_width();
  // product_slider_arrow();
  //  console.log('hi');

  if ($('body').hasClass('template-collection') || $('body').hasClass('template-index')) {
    remove_decimal();
  }
  if ($('body').hasClass('template-product')) {
    relpt_remove_decimal();
  }
});
function remove_decimal() {
  if ($(window).width() < 769) {
    if (!$('body').hasClass('remove_decimal')) {
      $('body .money').each(function () {
        $(this).html($(this).html().split(".")[0]);
      });
      $('body').addClass('remove_decimal');
    }
  } else {
    if ($('body').hasClass('remove_decimal')) {
      $('body .money').each(function () {
        $(this).html($(this).html() + '.00');
      });
      $('body').removeClass('remove_decimal');
    }
  }
}
function relpt_remove_decimal() {
  if ($(window).width() < 769) {
    if (!$('.related_product_box').hasClass('remove_decimal')) {
      $('.related_product_box .money').each(function () {
        $(this).html($(this).html().split(".")[0]);
      });
      $('.related_product_box').addClass('remove_decimal');
    }
  } else {
    if ($('.related_product_box').hasClass('remove_decimal')) {
      $('.related_product_box .money').each(function () {
        $(this).html($(this).html() + '.00');
      });
      $('.related_product_box').removeClass('remove_decimal');
    }
  }
}
function scroll_window() {
  //var scroll_h = $('.gallery-section .full_section.active').offset().top- ($(window).height()/2);

  var scroll_h = parseInt($('.gallery-section .full_section.active').attr('data-top'));
  scroll_h -= 180;
  $("html, body").animate({
    scrollTop: scroll_h
  }, "slow");
  $('.gallery-section .full_section').removeClass('active');
}
function slider_width() {
  if ($('.page-container .page-width').length > 0) {
    $('.desktop_slider .slideshow  button.slick-prev, .desktop_slider .slideshow  button.slick-next').css('width', $('.page-container .page-width').offset().left);
  }
}
function fixed_sidebar() {
  var w_width = $(window).width();
  if ($('.product_sidebar').length == 0 || w_width < 769) {
    $('.product_sidebar_inner').removeAttr('topfix-active');
    return;
  }
  var header_h = $('#shopify-section-header').height();
  var sidebar_w = $('.product_sidebar').width();
  var sidebar_h = $('.product_sidebar').height();
  var sidebar_top = $('.product_sidebar').offset().top;
  var footerRelatedProducts = $('#shopify-section-related-products');
  if (footerRelatedProducts.length) {
    var footer_h = footerRelatedProducts.offset().top;
  }
  var wnd_scroll = $(window).scrollTop();
  var sidebar_top1 = sidebar_top - wnd_scroll - header_h;
  if (sidebar_top1 < 85) {
    $('.product_sidebar_inner').css('width', sidebar_w);
    $('.product_sidebar').addClass('topfix-active');
  } else {
    $('.product_sidebar').removeClass('topfix-active');
    $('.product_sidebar_inner').removeAttr('style');
  }
  var tuch_footer = wnd_scroll + sidebar_top + sidebar_h + 130;
  if (footerRelatedProducts.length) {
    if (footer_h < tuch_footer) {
      $('.product_sidebar').addClass('bottomfix-active');
    } else {
      $('.product_sidebar').removeClass('bottomfix-active');
    }
  }
}
function show_contact_gallery() {
  //'/pages/contact-us?gallery=1'
  var url = $(location).attr('href');
  var cont_url = url.split("?gallery=1");
  if (cont_url.length > 1) {
    $('.add_extra_filed .outer_style').hide();
    $('.full_contactform').show();
    $('.add_extra_filed').find('input').removeClass('required');
    $('.add_extra_filed .outer_style[data-name="3"]').find('input').addClass('required');
    $('.add_extra_filed .outer_style[data-name="3"]').show();
    $('.add_extra_filed .outer_style[data-hide="3"]').hide();
    $('.cp_select_option').html($('.cp_dd_option li[data-option="3"]').html());
  }
}
function error_msg_show(id, error_mg) {
  if (id.val() == '') {
    id.next('.error_input').html(error_mg).show();
    id.addClass('error_txt'); //.focus()
    return 0;
  }
}
function valid_email(id, msg_email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  var email = id.val();
  if (!emailReg.test(email)) {
    id.next('.error_input').html(msg_email).show();
    id.addClass('error_txt'); //.focus()
    return 0;
  } else {
    id.removClass('error_txt');
    id.next('.error_input').hide();
    return 1;
  }
}

/* function setCookie(key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}*/

function australiaCustomer() {
  var checkInt = 0;
  var geoPopup = $(".recommendation-modal__container");
  //console.log(geoPopup, geoPopup.length)
  if (geoPopup.find(".recommendation-modal__message .recommendation-modal__message--bold").text() == "Australia") {
    //console.log("found")
    clearInterval(checkLocation);
    var currency = $('.site-header__icons-wrapper .curCurrency');
    var title = geoPopup.find("h2.recommendation-modal__message");
    var firstLine = geoPopup.find(".recommendation-modal__benefits ul li:first-of-type");
    var secondLine = geoPopup.find(".recommendation-modal__benefits ul li:nth-of-type(2)");
    var button = geoPopup.find('form button.recommendation-modal__button');
    title.text('Welcome to True Grit Texture Supply');
    firstLine.text('Shop and pay in Australian dollars');
    //secondLine.text('All prices include GST');
    secondLine.hide();
    button.text('Shop Now in AUD $');
    //console.log('Updated Australia Popup');
  } else {
    //console.log('...');

    if (Shopify.country == "AU" || checkInt == 5000) {
      console.log("cleared");
      clearInterval(checkLocation);
    }
    checkInt += 100;
  }
}
$(document).ready(function () {
  var checkLocation;
  // console.log(Shopify.country);
  checkLocation = setInterval(australiaCustomer, 200);
});

/* $(document).on('click','.okeReviews-reviewsCarousel-heading, .okeReviews-starRating', function() {
  location.href = '/pages/reviews';
}); */

//Update Header on Homepage scroll
var homeHeader = $('body.template-index').find('.header_section');
if (homeHeader.length) {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 100) {
      homeHeader.addClass('relative');
    } else {
      homeHeader.removeClass('relative');
    }
  });
}

//Custom Modal for Sales Icons
$('a.icon-modal-trigger').click(function () {
  var iconPageContent = $(this).parent().find('.sale-icon-page-content').html();
  // var iconClose = $(this).parent().parent().find('.li_info_close');
  $('.popup_full').html(iconPageContent);
  // iconClose.clone().appendTo('.popup_full');
  //$('.popup_full').append(iconClose);
  // $('.popup_full').css('overflow-y', 'scroll');
  $('.popup_full').fadeIn('fast');
  $('body').addClass('fxd-active');
});
var productAccordion = $('.product-accordion');
if (productAccordion.length) {
  var allPanels = productAccordion.find('.item-content');
  var hidePanel = productAccordion.find('.item-content:not(.open)').hide();
  var accordionTrigger = productAccordion.find('.item-toggle');
  accordionTrigger.click(function (e) {
    var toggleContent = $(this).next();
    if (toggleContent.hasClass('open')) {
      toggleContent.slideUp();
      toggleContent.add($(this)).removeClass('open');
    } else {
      allPanels.slideUp();
      accordionTrigger.removeClass('open');
      toggleContent.addClass('open').slideDown();
      $(this).addClass('open');
    }
    return false;
  });
}
function quickViewCartUpsellInit(_btn) {
  _btn.click(function (e) {
    e.preventDefault();
    var productHandle = String($(this).closest(".upsell-image").next(".upsell-text").find("h3 a").attr('href')).split("?");
    getQuickViewProd(productHandle[0].replace("/products/", ""));
    window.SLIDECART_CLOSE();
  });
}
function addToCartButton(wrapper) {
  wrapper.submit(function (e) {
    if ($(this).find('button[type="submit"]').hasClass('btn_disabled')) {
      return false;
    }
    e.preventDefault();
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      //data: wrapper.find('form[action="/cart/add"]').serialize(),
      data: wrapper.serialize(),
      async: false,
      success: function success(line_item) {
        if (typeof callback === 'function') {
          callback(line_item, form);
        }
      },
      complete: function complete(jqxhr, text) {
        update_cart();
        if (wrapper.closest('.popup_full').length) {
          wrapper.closest('.popup_full').find(".li_info_close").trigger("click");
        }
      }
    });
  });
}
function customBundleButton() {
  var bundleButton = $('.product-single .bundle_button');
  if (bundleButton.length) {
    bundleButton.click(function (e) {
      e.preventDefault();
      $('.popup_full').html($('#discountOfferDetails.popup_outer').html()); //.addClass("not_full");
      $('.popup_full').fadeIn('fast');
      $('body').addClass('fxd-active');
    });
  }
}
$(document).ready(function () {
  if ($('body').hasClass('template-collection')) {
    var collectionFooter = $('.collection-footer');
    if (collectionFooter.length) {
      var questions = collectionFooter.find('.question');
      var closedQuestions = collectionFooter.find('.accordion-toggle:not(.open) + .question'); // Updated selector
      var answers = collectionFooter.find('.answer');
      var closedAnswers = collectionFooter.find('.accordion-toggle:not(.open) + .answer'); // Updated selector
      closedAnswers.hide();
      questions.click(function () {
        var currentAnswer = $(this).next('.answer');
        currentAnswer.slideToggle();
        $(this).toggleClass('open');
        closedAnswers.not(currentAnswer).slideUp();
        closedQuestions.not($(this)).removeClass('open');
      });
    }
  }

  //Move Upsells on Mobile
  if ($('body').hasClass('template-product')) {
    var moveUpsells = function moveUpsells() {
      var mobileUpsellsWrapper = $('.mobile-upsells-wrapper');
      if (window.innerWidth < 980) {
        // Only clone and append if it hasn't already been added
        if (mobileUpsellsWrapper.length && mobileUpsellsWrapper.find('.bundle-upsell-wrapper').length === 0) {
          console.log('need to move it!');
          originalUpsells.clone().addClass('mobile-upsells').appendTo(mobileUpsellsWrapper);
        }
      }
    };
    var originalUpsells = $('.bundle-upsell-wrapper');
    moveUpsells();
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        moveUpsells();
      }, 400);
    });
  }
});